import _ from 'lodash';

import {toGetQuery} from 'utils/urls';

export const resizeImageWithImgix = (url, options) => {
  /*
   * This func adds query parameters that are then used by imgIX to resize the image.
   * For reference check all options here https://docs.imgix.com/apis/url/size
   */
  if (_.isNil(url)) {
    return undefined;
  }

  const imgixParams = toGetQuery(options);
  let unifier = '?';

  if (url.includes(unifier)) {
    unifier = '&';
  }

  return `${url}${unifier}${imgixParams}`;
};
